import React, { useState, useEffect } from 'react';
import { SmilePlus, Star, ExternalLink } from 'lucide-react';
import { supabase } from '../../../lib/supabase';

// Provider-specific Google review links and names mapping
const providerReviewLinks = {
  // Real provider IDs from the system and their Google review links
  '1': 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifM1tNrNth0oXGMnzB5s7ACSlbPVIg:1749264931326&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E1JrdL_oc40dmWbs6BkN9bey3UX0eGTf9_BGjPUdp3KsSTSTBHkkpfP58tL2H36H-KtdgDm7fjPSi-W_AWEKiYFYXQ6ThEah0RlhwRKenHr6k5zbxQ%3D%3D&q=Narbeh+Tovmassian,+MD,+FACP+Reviews&sa=X&ved=2ahUKEwjC-OXWp96NAxUARzABHUwhIX0Q0bkNegQIIBAE&biw=1728&bih=900&dpr=2#lrd=0x80c2c1a0086064dd:0x4b1f004e14a1bde2,3,,,,', // Narbeh Tovmassian, MD
  '2': 'https://www.google.com/search?q=Dr.+Garen+Derhartunian+MD%2C+FACP&oq=Dr.+Garen+Derhartunian+MD%2C+FACP&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigATIHCAYQIRiPAjIHCAcQIRiPAtIBBzQ4MGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8&lqi=Ch9Eci4gR2FyZW4gRGVyaGFydHVuaWFuIE1ELCBGQUNQSMS0_YXHq4CACFozEAAQARACEAMQBBgBGAIYAyIdZHIgZ2FyZW4gZGVyaGFydHVuaWFuIG1kIGZhY3AqAggDkgEJaW50ZXJuaXN0mgEjQ2haRFNVaE5NRzluUzBWSlEwRm5TVVEyWjNJeWQySlJFQUWqAWoQASohIh1kciBnYXJlbiBkZXJoYXJ0dW5pYW4gbWQgZmFjcCgAMiAQASIcheApoPBPlFgg1c63DBlWj4GWYasNG8uBEEoSZDIhEAIiHWRyIGdhcmVuIGRlcmhhcnR1bmlhbiBtZCBmYWNw4AEA-gEECHYQSg#lkt=LocalPoiReviews&rlimm=562424610253357070&lrd=0x80c2c10aaa9327ad:0x7ce22340316c00e,3,,,,', // Garen Derhartunian, MD
  '4': 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifOuRAs033GxcJW1V3VI_T7pPaDCWg:1749265058004&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-EyaVq1upYbdLaKgSCHiDXioxonVPnnt1udNvYwV7pm9tOJVS7mkwSEBe7P3q4EPY-kchuCrrk8fdU6HC3DRoeCtehVM1Aw2lMX10eUl6mmnP3Kckfg%3D%3D&q=Dr.+Andreh+Carapiet+Reviews&sa=X&ved=2ahUKEwjJ2JmTqN6NAxUeMlkFHQkVFyIQ0bkNegQIHxAE&biw=1728&bih=900&dpr=2#lrd=0x80c2ea0da4c16e0b:0xeff8f5e38944f5a2,3,,,,', // Andreh Carapiet, MD
  '15': 'https://www.google.com/search?q=manvel+khondradzyan&oq=manvel+khondradzyan&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigATIHCAYQIRiPAjIHCAcQIRiPAtIBCDk0MjNqMGo5qAIAsAIB&sourceid=chrome&ie=UTF-8&lqi=ChNtYW52ZWwga29uZHJhZHpoeWFuSKSk0KO5toCACFodEAAQARgAGAEiE21hbnZlbCBrb25kcmFkemh5YW6SAQlpbnRlcm5pc3SqATwQATIfEAEiG_MML-S0fCP-WqChPExDMW8rAnr2ndwGtvF6dTIXEAIiE21hbnZlbCBrb25kcmFkemh5YW7gAQA#rlimm=13280921340206410397&lrd=0x80c2c055ce8fffff:0xb84f4f97f4e86a9d,3,,,,', // Manvel Kondradzhyan, MD
  '20': 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifPWSzlBXSslgSRrfTyW7xvZmIul_A:1749264785578&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E5DHIPSMRjYnSGoY51OXGjaXFJwQPfucws4wFlWmJzhZsfQDfxLnHQF7NHFAZCTAiM1gHQPzCl-PDJYO9x11NyTZczlTxRK9uqzGGzsgNpEnUAtnzA%3D%3D&q=Leah+Ghadimi,+NP+Reviews&sa=X&ved=2ahUKEwjsl6aRp96NAxWuTTABHRGyBtEQ0bkNegQINRAE&biw=1728&bih=900&dpr=2#lrd=0x80c2ebdcaeb94081:0xa87c73dfa4452436,3,,,,', // Leah Ghadimi
  '23': 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifPIP7eDRW8vDbUD6aIbWwRAAg1o9w:1749264704366&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E4gXOHs18Xi450bSN_JredXBgQM3J5Tey0bYBRw8Bi5ddMViQ3T6EScs2_ivYP-4z9-uXXtNiDlS-lhWeI07gUHBAU1SOz8Zgr__6R4fAGhJccf9uA%3D%3D&q=Arazin+Minasian,+MD+Reviews&sa=X&ved=2ahUKEwjBr8nqpt6NAxVrQzABHchUIuEQ0bkNegQIKRAE&biw=1728&bih=900&dpr=2#lrd=0x80c2c1c32b0df2af:0xe86a907ce13c5c29,3,,,,', // Arazin Minasian, MD
  '26': 'https://www.google.com/search?q=Dr.+Taleen+Akopian+DO&oq=Dr.+Taleen+Akopian+DO&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIICAEQABgWGB4yCggCEAAYgAQYogQyCggDEAAYgAQYogQyCggEEAAYgAQYogQyCggFEAAYgAQYogTSAQc1NDdqMGo5qAIAsAIA&sourceid=chrome&ie=UTF-8&lqi=ChVEci4gVGFsZWVuIEFrb3BpYW4gRE9IsbyWs7G4gIAIWiQQABABEAIQAxgBGAIYAyIUZHIgdGFsZWVuIGFrb3BpYW4gZG-SAQlpbnRlcm5pc3SaASNDaFpEU1VoTk1HOW5TMFZKUTBGblRVTlJORFZxTTJGQkVBRaoBRRABKgYiAmRyKAAyHxABIhvv1C0sNUNqdo92pytep1lXkEmpDeooUlyP5p8yGBACIhRkciB0YWxlZW4gYWtvcGlhbiBkb-ABAPoBBQj0BBBL#rlimm=9197660027617303745&lrd=0x80c2ebd2605eb8f9:0x7fa4a71056f05cc1,3,,,,', // Taleen Akopian, DO
  '27': 'https://www.google.com/search?q=Liya+Zadoryan+NP&oq=Liya+Zadoryan+NP&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRiPAjIHCAIQIRiPAjIHCAMQIRiPAtIBBzQ2OWowajmoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0x80c2eb70148bb3d1:0x1ccad0d33f4a97b6,3,,,,', // Liya Zadoryan, NP
  '31': 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifNmOjrZGrixBxMqHjLxEuCOdE-yzg:1749264794388&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-ExAS3nOdPu-D2oIMxBJ5lqN4CiBf8sDlaI5-NhFDExQVuE1XLVFrvYFju3pYT_ARehKPAm-Y4waQ0oNp1y9Jx5oHi-EvoL2JHG_YwjVF7SZ-oymuug%3D%3D&q=Anna+Arakelyan,+MD+Reviews&sa=X&ved=2ahUKEwi14L-Vp96NAxUVQjABHQtzAVQQ0bkNegQIIhAE&biw=1728&bih=900&dpr=2#lrd=0x80c2c126df3aea6b:0x2978ad894680b1b3,3,,,,', // Anna Arakelyan, MD
  '34': 'https://www.google.com/search?q=Marina+Tovmasian+&sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifMxKQxrcEr2v-JvY9E1-C5HeEcfDg%3A1749264830075&ei=vqlDaMaoBO26kPIPx_Cb0Ag&ved=0ahUKEwjG_8Gmp96NAxVtHUQIHUf4BooQ4dUDCBA&uact=5&oq=Marina+Tovmasian+&gs_lp=Egxnd3Mtd2l6LXNlcnAiEU1hcmluYSBUb3ZtYXNpYW4gMgQQIxgnMgYQABgWGB4yAhAmMgIQJjIIEAAYgAQYogQyCBAAGIAEGKIEMgUQABjvBUiVBVD6Alj6AnABeAGQAQCYAW2gAW2qAQMwLjG4AQPIAQD4AQGYAgKgAnbCAgoQABiwAxjWBBhHmAMAiAYBkAYHkgcDMS4xoAegBbIHAzAuMbgHc8IHBTAuMS4xyAcG&sclient=gws-wiz-serp#lrd=0x80c2c1cea0659e4b:0x5a5c0580ca78ac41,3,,,,', // Marina Tovmasian, FNP-C
  '39': 'https://g.co/kgs/KarmenVardanyanReview', // Karmen Vardanyan, NP-C
  '41': 'https://g.co/kgs/HaykPapukhyanReview', // Hayk Papukhyan, MD
  '42': 'https://www.google.com/search?q=devinder+ghandi&oq=devinder+ghandi&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTISCAEQLhgKGK8BGMcBGIAEGI4FMg0IAhAAGIYDGIAEGIoFMgoIAxAAGIAEGKIEMgoIBBAAGKIEGIkFMgoIBRAAGIAEGKIEMgoIBhAAGIAEGKIE0gEIMjY1MWowajmoAgCwAgE&sourceid=chrome&ie=UTF-8#lrd=0x80c2c10aa44d15b5:0x4b22431cab4b86d,3,,,,', // Devinder Gandhi, MD
  '43': 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifPUYmPMoHxHeissn_3E5OtrbFbQ4A:1749264720370&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E_3nKEC-DWEVcWfSu3hTlt-R7XM78WzvSirJ5UHr6lYxEJXv4IKZ8yd_kMlMSl71HOyX9RYCNYRkaegiPlJ4pn4TkZOGAin14lZapdcYfibIMKpWcJr9x_ABHciBMUiWuVyNaac%3D&q=Narineh+Yermian,+DO:+Internal+Medicine+Reviews&sa=X&ved=2ahUKEwjXj5rypt6NAxUBRzABHZ5pFtMQ0bkNegQIJhAE&biw=1728&bih=900&dpr=2#lrd=0x80c2c12c8e195bd9:0xf17b44127afda35f,3,,,,', // Narineh Yermian, DO
  '36': 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifNoZdNkf9ye44CuIbVM47itbXje8A:1749264745296&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E5GjkJqBTv1M8lQg35q2Qm8dzVFGTQKiKBAbMxroKy_lcEf9pm53wc9oT-O-61aDxtv-1ElUmLLaFo0UnH3ETvjDa4JEiKJYW-YlqfWFpUYv8RHFHA%3D%3D&q=Lina+Acopians,+DO+Reviews&sa=X&ved=2ahUKEwjPwov-pt6NAxWfRTABHRZmBmoQ0bkNegQIJhAE&biw=1728&bih=900&dpr=2#lrd=0x80c2c17bb67ca1b7:0xa620103b9e1fc333,3,,,,' //Lina Acopians
  // Non-person entities and other providers without specific links will fall back to default
};

// Provider names mapping
const providerNames = {
  '1': 'Dr. Narbeh Tovmassian',
  '2': 'Dr. Garen Derhartunian',
  '4': 'Dr. Andreh Carapiet',
  '15': 'Dr. Manvel Kondradzhyan',
  '20': 'Dr. Leah Ghadimi, NP',
  '23': 'Dr. Arazin Minasian',
  '26': 'Dr. Taleen Akopian',
  '27': 'Dr. Liya Zadoryan, NP',
  '30': 'IV Hydration', // Special mapping for IV Hydration service
  '31': 'Dr. Anna Arakelyan',
  '34': 'Dr. Marina Tovmasian, FNP-C',
  '36': 'Dr. Lina Acopians, DO',
  '39': 'Dr. Karmen Vardanyan, NP-C',
  '41': 'Dr. Hayk Papukhyan',
  '42': 'Dr. Devinder Gandhi',
  '43': 'Dr. Narineh Yermian'
};

// City-specific Google review links
const cityReviewLinks = {
  'GLENDALE': 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifNjlB2B74vimCaMEUa7GNITc-xthw:1749265237187&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E0tUXvY-hx2aX-rsRt3986hgkLHRhzki0S7EyaDNlFsr3r0OT20biVEsUyxmdJYHmKX4yVsC6ertyWmjSggSw5_59oRZQCVeQQ1OJKly61TBaA3o0A%3D%3D&q=Elevate+Health+Group+Reviews&sa=X&ved=2ahUKEwjRj9LoqN6NAxXUTDABHULdNvUQ0bkNegQILBAE&biw=1728&bih=900&dpr=2#lrd=0x80c2c1a0086064dd:0x36fc58c19cc0c766,3,,,,',
  'BURBANK': 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifOa4330Qtgc0VQjUcoG6K4VuN0viA:1749265224852&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-Ew-ah7WHqwFwjKTfdqjVjEI-p4vsgmM1V1JZcdV_8sFF4P8LtNpeczNtLSI37f5dtM9IrY5J1wSV4bj-Zav6Bg_HH62DFHJdE05Czu68VgQ-nuvx5A%3D%3D&q=Elevate+Health+Group+Reviews&sa=X&ved=2ahUKEwitq-HiqN6NAxWknIQIHcoREgkQ0bkNegQIKxAE&biw=1728&bih=900&dpr=2#lrd=0x80c2bfb33bd8f0cd:0x647bc3b439d5f8e6,3,,,,',
  'LA CANADA': 'https://www.google.com/search?q=elevate+health+group+la+canada&oq=elevate+health+group+la+canada&gs_lcrp=EgZjaHJvbWUqCggAEAAY4wIYgAQyCggAEAAY4wIYgAQyEAgBEC4YrwEYxwEYgAQYjgUyCAgCEAAYFhgeMggIAxAAGBYYHjIKCAQQABiABBiiBDIKCAUQABiABBiiBDIGCAYQRRg8MgYIBxBFGDzSAQg0MDA3ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#lrd=0x80c2eb8d35f8bd31:0x10312049b347b63b,3,,,,'
};

// Department to city mapping based on department data
const departmentReviewLinks = {
  // Main locations - mapping each department ID to its city's review link
  '1': cityReviewLinks['GLENDALE'], // Main Office
  '18': cityReviewLinks['GLENDALE'], // autoECommerce - Elevate Health Group
  '19': cityReviewLinks['GLENDALE'], // autoContract - Elevate Health Group
  '39': cityReviewLinks['GLENDALE'], // autoECommerce - ANDREH CARAPIET MD INC
  '40': cityReviewLinks['GLENDALE'], // autoECommerce - Elevate Health Group - Hospital Bi
  '41': cityReviewLinks['GLENDALE'], // autoContract - ANDREH CARAPIET MD INC
  '42': cityReviewLinks['GLENDALE'], // autoContract - Elevate Health Group - Hospital Bil
  '43': cityReviewLinks['GLENDALE'], // Adventist Health Glendale
  '45': cityReviewLinks['GLENDALE'], // Adventist Health Glendale TCU
  '47': cityReviewLinks['GLENDALE'], // Autumn Hills Health Care Center
  '49': cityReviewLinks['GLENDALE'], // Broadway Manor Care Center
  '51': cityReviewLinks['BURBANK'], // College Vista (Los Angeles, but using Burbank for the 3 cities requirement)
  '53': cityReviewLinks['GLENDALE'], // Glen Terra Assisted Living
  '55': cityReviewLinks['GLENDALE'], // Glendale Memorial Hospital
  '57': cityReviewLinks['LA CANADA'], // La Crescenta Health Care Center (mapping to LA CANADA)
  '59': cityReviewLinks['GLENDALE'], // Leisure Glen Post Acute Care Center
  '62': cityReviewLinks['BURBANK'], // New Vista Nursing & Rehabilitation Center (Sunland, but using Burbank)
  '64': cityReviewLinks['BURBANK'], // North Valley Nursing Center (Tujunga, but using Burbank)
  '66': cityReviewLinks['BURBANK'], // Oakpark Healthcare Center (Tujunga, but using Burbank)
  '68': cityReviewLinks['LA CANADA'], // Pasadena Meadows Nursing Center (mapping to LA CANADA)
  '70': cityReviewLinks['GLENDALE'], // USC Verdugo Hills Hospital- TCU
  '72': cityReviewLinks['GLENDALE'], // USC Verdugo Hills Hospital
  '74': cityReviewLinks['LA CANADA'], // Montrose Healthcare Center (mapping to LA CANADA)
  '75': cityReviewLinks['GLENDALE'], // Glen Terra Assisted Living_AC
  '76': cityReviewLinks['GLENDALE'], // Adventist Health Glendale_AC
  '77': cityReviewLinks['GLENDALE'], // Adventist Health Glendale TCU_AC
  '78': cityReviewLinks['GLENDALE'], // Autumn Hills Health Care Center_AC
  '79': cityReviewLinks['GLENDALE'], // Broadway Manor Care Center_AC
  '80': cityReviewLinks['BURBANK'], // College Vista_AC (Los Angeles, but using Burbank)
  '99': cityReviewLinks['LA CANADA'], // La Crescenta Health Care Center_AC (mapping to LA CANADA)
  '82': cityReviewLinks['GLENDALE'], // Leisure Glen Post Acute Care Center_AC
  '83': cityReviewLinks['LA CANADA'], // Montrose Healthcare Center_AC (mapping to LA CANADA)
  '84': cityReviewLinks['BURBANK'], // New Vista Nursing & Rehabilitation Center_AC (Sunland, but using Burbank)
  '85': cityReviewLinks['BURBANK'], // North Valley Nursing Center_AC (Tujunga, but using Burbank)
  '86': cityReviewLinks['BURBANK'], // Oakpark Healthcare Center_AC (Tujunga, but using Burbank)
  '87': cityReviewLinks['LA CANADA'], // Pasadena Meadows Nursing Center_AC (mapping to LA CANADA)
  '88': cityReviewLinks['GLENDALE'], // USC Verdugo Hills Hospital- TCU_AC
  '89': cityReviewLinks['GLENDALE'], // Glendale Memorial Hospital and Health Center_AC
  '90': cityReviewLinks['GLENDALE'], // USC Verdugo Hills Hospital_AC
  '110': cityReviewLinks['BURBANK']  // United Care Center Inc (Panorama City, but using Burbank)
};

// Default Google review link (used if no provider-specific link or alternating)
const defaultGoogleReviewLink = 'https://www.google.com/search?sca_esv=caaaec4e7ece04a6&sxsrf=AE3TifNjlB2B74vimCaMEUa7GNITc-xthw:1749265237187&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E0tUXvY-hx2aX-rsRt3986hgkLHRhzki0S7EyaDNlFsr3r0OT20biVEsUyxmdJYHmKX4yVsC6ertyWmjSggSw5_59oRZQCVeQQ1OJKly61TBaA3o0A%3D%3D&q=Elevate+Health+Group+Reviews&sa=X&ved=2ahUKEwjRj9LoqN6NAxXUTDABHULdNvUQ0bkNegQILBAE&biw=1728&bih=900&dpr=2#lrd=0x80c2c1a0086064dd:0x36fc58c19cc0c766,3,,,,';
const defaultYelpReviewLink = 'https://www.yelp.com/biz/elevate-health-group-glendale';

export function FeedbackSystem({ providerId, patientName = '' }) {
  const [rating, setRating] = useState(0);
  const [showThankYou, setShowThankYou] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [name, setName] = useState(patientName);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [showExternalLinks, setShowExternalLinks] = useState(false);
  const [googleReviewLink, setGoogleReviewLink] = useState(defaultGoogleReviewLink);
  const [providerName, setProviderName] = useState('');
  const [skipExternalLinks, setSkipExternalLinks] = useState(false);
  // Store the skipExternalLinks value when submitting to persist through state changes
  const [submittedWithSkipLinks, setSubmittedWithSkipLinks] = useState(false);

  // Determine which Google review link to use and set provider name on component mount
  useEffect(() => {
    selectGoogleReviewLink();
    setProviderNameFromId();
  }, [providerId]);

  // Update name state when patientName prop changes
  useEffect(() => {
    if (patientName) {
      setName(patientName);
    }
  }, [patientName]);

  // Function to set the provider name based on the providerId
  const setProviderNameFromId = () => {
    if (providerId && providerNames[providerId]) {
      setProviderName(providerNames[providerId]);
    } else {
      setProviderName('');  // Clear the provider name if no match
    }
  };

  // Get departmentId from URL parameters if available
  const getDepartmentIdFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('departmentId');
  };
  
  // Function to select between provider-specific and default Google review link
  const selectGoogleReviewLink = async () => {
    // Extract departmentId from URL parameters
    const departmentId = getDepartmentIdFromUrl();
    console.log(`Extracted departmentId from URL: ${departmentId || 'none'}`);
    
    // If no provider ID is provided, check for department-specific link
    if (!providerId) {
      if (departmentId && departmentReviewLinks[departmentId]) {
        console.log(`Using department-specific link for department ${departmentId}`);
        setGoogleReviewLink(departmentReviewLinks[departmentId]);
      } else {
        console.log('No providerId or departmentId available, using default link');
        setGoogleReviewLink(defaultGoogleReviewLink);
      }
      return;
    }

    // Check if we have a provider-specific link
    const hasProviderLink = providerReviewLinks[providerId] !== undefined;
    
    if (!hasProviderLink) {
      if(departmentId && departmentReviewLinks[departmentId]){
      // No provider-specific link, use default
      setGoogleReviewLink(departmentReviewLinks[departmentId]);
      }
      else
      {
        selectGoogleReviewLink(defaultGoogleReviewLink);
      }
      return;
    }

    try {
      // Get provider visit count from database
      // If we have a patientId in props, use it, otherwise use anonymous counter
      const countKey = `provider_visits_${providerId}`;
      
      // Get the current visit count
      const { data: visitData, error } = await supabase
        .from('provider_visit_counts')
        .select('visit_count')
        .eq('counter_key', countKey)
        .single();
      
      // Initialize or increment the counter
      let currentCount = 0;
      
      if (error || !visitData) {
        // Create new counter starting at 1
        const { data } = await supabase
          .from('provider_visit_counts')
          .insert([{
            counter_key: countKey,
            visit_count: 1
          }])
          .select();
        
        if (data) currentCount = 1;
      } else {
        // Increment existing counter
        currentCount = visitData.visit_count + 1;
        await supabase
          .from('provider_visit_counts')
          .update({ visit_count: currentCount })
          .eq('counter_key', countKey);
      }
      
      // Every 4th visit (remainder 0 when divided by 4) gets the provider link
      const useProviderLink = currentCount % 4 === 0;
      
      if (useProviderLink) {
        setGoogleReviewLink(providerReviewLinks[providerId]);
        console.log(`Using provider-specific Google review link for provider ${providerId} (visit #${currentCount})`);
      } else {
        // When not using provider link, check for department-specific link
        const departmentId = getDepartmentIdFromUrl();
        if (departmentId && departmentReviewLinks[departmentId]) {
          setGoogleReviewLink(departmentReviewLinks[departmentId]);
          console.log(`Using department-specific link for department ${departmentId} (provider ${providerId}, visit #${currentCount})`);
        } else {
          // No department link available, use default
          setGoogleReviewLink(defaultGoogleReviewLink);
          console.log(`Using default Google review link for provider ${providerId} (visit #${currentCount})`);
        }
      }
    } catch (err) {
      console.error('Error tracking provider visits:', err);
      // Fallback to default link in case of error
      setGoogleReviewLink(defaultGoogleReviewLink);
    }
  };

  // Function to determine if we should show feedback input for high ratings using database counter
  const shouldShowFeedbackForHighRating = async () => {
    try {
      // Use a global counter key for high rating feedback
      const countKey = 'high_rating_feedback_counter';
      
      // Get the current count from database
      const { data: counterData, error } = await supabase
        .from('feedback_counters')
        .select('count_value')
        .eq('counter_key', countKey)
        .single();
      
      // Initialize or increment the counter
      let currentCount = 0;
      
      if (error || !counterData) {
        // Create new counter starting at 1
        const { data } = await supabase
          .from('feedback_counters')
          .insert([{
            counter_key: countKey,
            count_value: 1
          }])
          .select();
        
        if (data) currentCount = 1;
      } else {
        // Increment existing counter
        currentCount = counterData.count_value + 1;
        await supabase
          .from('feedback_counters')
          .update({ count_value: currentCount })
          .eq('counter_key', countKey);
      }
      
      // Show feedback form on every 10th high rating (when count % 10 === 0)
      return currentCount % 10 === 0;
    } catch (err) {
      console.error('Error tracking high rating feedback counter:', err);
      // Fallback to showing feedback (safer option if DB fails)
      return true;
    }
  };

  // Flag to prevent multiple simultaneous calls and track loading state
  const [isProcessingRating, setIsProcessingRating] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  // Function to set the Google review link based on providerId
  const handleRatingChange = async (newRating) => {
    // Prevent multiple simultaneous rating processing
    if (isProcessingRating) return;
    
    setIsProcessingRating(true);
    setRating(newRating);
    
    // If it's a high rating (5), determine whether to show feedback form or external links
    // based on the database counter
    if (newRating > 4) {
      // Set loading while we check the database
      setIsLoading(true);
      
      try {
        // Get result from database counter
        const showFeedbackInput = await shouldShowFeedbackForHighRating();
        
        // Add a small delay to ensure state updates properly
        setTimeout(() => {
          if (showFeedbackInput) {
            // In the 10% case (1 out of 10), set flag to skip external links after submission
            setSkipExternalLinks(true);
            console.log('High rating will show feedback input (1 out of 10 case)');
          } else {
            // In the 90% case (9 out of 10), direct to external links
            setSkipExternalLinks(false);
            console.log('High rating will skip to external links (9 out of 10 case)');
          }
          setIsLoading(false);
          setIsProcessingRating(false);
        }, 100);
      } catch (error) {
        // On error, default to showing feedback form (safer option)
        console.error('Error determining feedback flow:', error);
        setSkipExternalLinks(true);
        setIsLoading(false);
        setIsProcessingRating(false);
      }
    } else {
      // For low ratings (1-4), we always show feedback and never show external links
      setSkipExternalLinks(true);
      setIsProcessingRating(false);
    }
  };

  const handleSubmit = async () => {
    if (rating === 0) return;
    if (!name.trim()) {
      setError('Please enter your name before submitting');
      return;
    }
    
    // Save the current skipExternalLinks state for after submission
    setSubmittedWithSkipLinks(skipExternalLinks);
    
    // For high ratings (5 stars), we don't need feedback text
    // But only in the 90% case where skipExternalLinks is false
    if (rating > 4 && !skipExternalLinks) {
      setShowExternalLinks(true);
      return;
    }
    
    setIsSubmitting(true);
    setError(null);

    // Determine if feedback should be public based on rating
    const isPublic = rating > 4;

    try {
      // Always submit to database first
      const { error: submitError } = await supabase
        .from('feedback')
        .insert([
          {
            rating,
            comment: feedback,
            name: name.trim(),  // Add patient name
            provider_id: providerId || null,  // Add provider ID
            provider_name: providerName || null,  // Add provider name
            platform:"Elevate",
            is_public: isPublic,
            created_at: new Date().toISOString(),

          }
        ]);

      if (submitError) throw submitError;
      
      // Show thank you message for all reviews
      setShowThankYou(true);
      console.log('isPublic:', isPublic);
      console.log('rating:', rating);
      console.log('skipExternalLinks at submission:', skipExternalLinks);
      console.log('submittedWithSkipLinks:', submittedWithSkipLinks);
      
      // Only reset the form for non-5-star ratings
      // We keep the form data for 5-star ratings in case the user
      // wants to go back after viewing external review links
      if (rating < 5) {
        setFeedback('');
        setName('');
        setRating(0);
      }
    } catch (err) {
      console.error('Error submitting feedback:', err);
      setError('Failed to submit feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle submission of positive feedback with external links
  const handlePositiveFeedbackSubmit = async () => {
    setIsSubmitting(true);
    setError(null);

    try {
      // Submit to database with empty comment for positive feedback
      const { error: submitError } = await supabase
        .from('feedback')
        .insert([
          {
            rating,
            comment: '', // Empty comment for positive feedback
            name: name.trim(),  // Add patient name
            provider_id: providerId || null,  // Add provider ID
            provider_name: providerName || null,  // Add provider name
            is_public: true,
            created_at: new Date().toISOString()
          }
        ]);

      if (submitError) throw submitError;
      
      // Continue showing external links
      setShowThankYou(true);
    } catch (err) {
      console.error('Error submitting positive feedback:', err);
      setError('Failed to submit feedback. Please try again.');
      setShowExternalLinks(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Render external review links directly
  if (showExternalLinks) {
    return (
      <div className="text-center p-8">
        <h2 className="text-2xl font-bold text-green-600 mb-4">Thank You for Your Positive Rating!</h2>
        <p className="text-gray-600 mb-6">
          We're so glad to hear you had a great experience. If you have a moment, we'd really appreciate it if you could share your feedback on Google—it helps others find us and means a lot to our team.
        </p>
        <div className="space-y-6">
          <div className="flex justify-center gap-4">
            <a
              href={googleReviewLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-green-500 border-2 border-green-500 text-white rounded-lg hover:bg-green-600 hover:border-green-600 transition-colors"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="mr-1">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                <path d="M1 1h22v22H1z" fill="none"/>
              </svg>
              Review on Google
              <ExternalLink size={18} />
            </a>
            {/* <button
              onClick={() => {
                setShowExternalLinks(false);
                setRating(0);
                setName('');
              }}
              className="inline-flex items-center px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors"
            >
              Start Over
            </button> */}
            {/* <a
              href={defaultYelpReviewLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-red-500 text-red-500 rounded-lg hover:bg-red-50 transition-colors"
            >
              <img 
                src="https://images.unsplash.com/photo-1580828343064-fde4fc206bc6?auto=format&fit=crop&q=80&w=24&h=24" 
                alt="Yelp" 
                className="w-6 h-6 rounded"
              />
              Review on Yelp
              <ExternalLink size={18} />
            </a> */}
          </div>
          {/* Start Over button moved up next to Google button */}
          {error && (
            <div className="mt-4 p-4 bg-red-50 text-red-600 rounded-lg">
              {error}
            </div>
          )}
        </div>
      </div>
    );
  }

  if (showThankYou) {
    // Check if the last submission was public (5 stars)
    console.log('rating:', rating);
    const wasPublic = rating > 4;
    console.log('wasPublic:', wasPublic);
    console.log('submittedWithSkipLinks in thank you screen:', submittedWithSkipLinks);
    
    return (
      <div className="text-center p-8">
        <h2 className="text-2xl font-bold text-green-600 mb-4">Thank You for Your Feedback!</h2>
        {wasPublic ? (
          <p className="text-gray-600 mb-4">
            Your feedback has been submitted and will be displayed publicly. We appreciate your support!
          </p>
        ) : (
          <p className="text-gray-600 mb-4">
            Your feedback has been submitted to our team. We'll use it to improve our services.
          </p>
        )}
        {wasPublic && !submittedWithSkipLinks ? (
          <div className="space-y-6">
            <p className="text-gray-600">Additionally, we'd love if you could share your positive experience on one of these platforms:</p>
            <div className="flex justify-center gap-4">
              <a
                href={googleReviewLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-green-500 border-2 border-green-500 text-white rounded-lg hover:bg-green-600 hover:border-green-600 transition-colors"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="mr-1">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  <path d="M1 1h22v22H1z" fill="none"/>
                </svg>
                Review on Google
                <ExternalLink size={18} />
              </a>
              <a
                href={defaultYelpReviewLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-red-500 text-red-500 rounded-lg hover:bg-red-50 transition-colors"
              >
                <img 
                  src="https://images.unsplash.com/photo-1580828343064-fde4fc206bc6?auto=format&fit=crop&q=80&w=24&h=24" 
                  alt="Yelp" 
                  className="w-6 h-6 rounded"
                />
                Review on Yelp
                <ExternalLink size={18} />
              </a>
            </div>
            <button
              onClick={() => setShowThankYou(false)}
              className="mt-6 px-6 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors"
            >
              Go Back
            </button>
          </div>
        ) : (
          <div>
            <p className="text-gray-600 mb-6">
              We appreciate your feedback and will use it to improve our services.
            </p>
            {/* <button
              onClick={() => {
                setShowThankYou(false);
                setFeedback('');
                setName('');
                setRating(0);
              }}
              className="px-6 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors"
            >
              Submit Another Response
            </button> */}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-md overflow-hidden">
      <div className="p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Share Your Experience
        </h2>
        
        {/* Name Input Field - Read-only if patient name was provided in URL */}
        <div className="mb-6">
          <label htmlFor="name" className="text-gray-600 mb-2 block">Your Name</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => patientName ? null : setName(e.target.value)}
            placeholder="Enter your name"
            readOnly={!!patientName}
            className={`w-full p-3 border rounded-lg ${patientName ? 'bg-gray-100 text-gray-700' : 'focus:ring-2 focus:ring-blue-500 focus:border-transparent'}`}
          />
        </div>

        {/* Provider Name Field - Auto-filled and readonly */}
        {providerName && (
          <div className="mb-6">
            <label htmlFor="providerName" className="text-gray-600 mb-2 block">Provider</label>
            <input
              type="text"
              id="providerName"
              value={providerName}
              readOnly
              className="w-full p-3 bg-gray-100 border rounded-lg text-gray-700"
            />
          </div>
        )}
        
        {/* Rating Selection */}
        <div className="mb-6">
          <p className="text-gray-600 mb-4">How would you rate your experience with us?</p>
          <div className="flex gap-4 justify-center">
            {[1, 2, 3, 4, 5].map((value) => (
              <button
                key={value}
                onClick={() => handleRatingChange(value)}
                className={`p-4 rounded-full transition-all ${
                  rating >= value 
                    ? 'bg-blue-500 text-white' 
                    : 'bg-gray-100 hover:bg-gray-200'
                } ${
                  rating === value ? 'scale-110' : ''
                }`}
              >
                <Star
                  size={24}
                  className={rating >= value ? 'fill-current' : ''}
                />
              </button>
            ))}
          </div>
          {/* <p className="mt-3 text-sm text-gray-500">
            {rating > 4 
              ? (skipExternalLinks ? "Great! Thank you for your feedback." : "Great! You'll be directed to leave a review on Google.")
              :""}
          </p> */}
        </div>

        {/* Error Message */}
        {error && (
          <div className="mb-4 p-4 bg-red-50 text-red-600 rounded-lg">
            {error}
          </div>
        )}

        {/* Feedback Form - Only show for low ratings (1-3 stars) */}
        {rating > 0 && (
          <div className="space-y-4">
            {(rating <= 4 || (rating > 4 && skipExternalLinks)) && (
              <textarea
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Tell us more about your experience..."
                className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                rows={4}
              />
            )}
            
            <button
              onClick={handleSubmit}
              disabled={isSubmitting || isLoading}
              className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting || isLoading ? 
                (isLoading ? 'Checking...' : 'Submitting...') : 
                (rating > 4 && !skipExternalLinks) ? 'Continue to Review Sites' : 
                'Submit Feedback'}
            </button>

            {rating <= 4 && (
              <p className="text-sm text-gray-500 mt-2 flex items-center gap-2 justify-center">
                Your feedback helps us improve our services
              </p>
            )}
            {rating > 4 && (
              <p className="text-sm text-gray-500 mt-2 flex items-center gap-2 justify-center">
                <SmilePlus size={16} />
                {!skipExternalLinks ? 
                  "We'll provide links to share your positive experience" :
                  "Thanks for sharing your positive experience with us"}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}